// EISM CO2 tooltip logic constants and helper function

// Tooltip messages
export const TOOLTIP_MESSAGES = {
  SYNC_REQUIRED: "Sync the dossier to get the latest Environmental Footprint data", // Priority 1
  MRB_EXCLUDED: "MRBR is not considered for calculations", // Priority 2 - As of now excluded this as message in GD is gonna change
  ALL_EXCLUDED : "ALL is not a valid input and is not considered for calculations" // Priority 3
};

// priority rules (The Mapper)
// The order here determines priority: Index 0 is checked first.
export const TOOLTIP_RULES = [
  {
    condition: (hasSelector,) => !hasSelector,
    message: TOOLTIP_MESSAGES.SYNC_REQUIRED,
  },
  {
    condition: (hasSelector, row) => row && row.includes("Overall / Dossier Level"),
    message: TOOLTIP_MESSAGES.ALL_EXCLUDED,
  },
];

